<template>
  <div>
     <photoshop-picker v-model="selected_color" @ok="handleAccept" @cancel="handleCancel" />
  </div>
</template>
<style type="text/css">
  div.vc-photoshop {
    background: #FFF;
    box-shadow: none;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    box-sizing: initial;
    width: 513px;
    font-family: "Nunito", sans-serif;
    margin: 30px auto;
  }
  div.vc-ps-head{
    display: none;
  }
  div.vc-hue-picker{
    width: 15px;
  }
</style>
<script>
  import { Photoshop } from 'vue-color'
  
  export default {
    components: {      'photoshop-picker': Photoshop }, 
    props: { 
      color: {
        default: '#FF005C',
        type: String
      },
      name: {
        type: String
      }
    },
    data () {
      return {
        selected_color: {
          "hex": this.color,
          "source": "hex"
        },
        input_name: this.name
      }
    },
    methods: {
      handleAccept () {
        this.$emit('newcolor',this.selected_color.hex);
      },
      handleCancel () {
        this.$emit('cancel');
      },
    }
  }
</script>
